import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { colors } from '../../../../../colorVars';
import { addWatchlistName } from '../../../../../stores/websocketStore/utils/outgoingMessages/alerts/addWatchlistName';
import { removeWatchlistName } from '../../../../../stores/websocketStore/utils/outgoingMessages/alerts/removeWatchlistName';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { useAlertsStore } from '../../../../../stores/websocketStore/_alertsStore';
import CloseWindowButton from '../../../../atomic/buttons/closeWindow/CloseWindowButton';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import { Body2, Body3 } from '../../../../atomic/text/Text';
import { WatchlistManagerListComponent } from './listComponent/WatchlistManagerListComponent';
import style from './WatchlistManagerComponent.module.css';

export const WatchlistManagerComponent = observer(
  ({ moduleId, layoutType }) => {
    const { layoutStore } = useWebsocketStore();
    const alertStore = useAlertsStore();

    const [selectedWatchlist, setSelectedWatchlist] = useState(null);
    const [newWatchlistName, setNewWatchlistName] = useState('');
    const [showDeletePrompt, setShowDeletePrompt] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const timeoutRef = useRef();

    const watchlistNameList = alertStore.listOfWatchlistNames || [];

    const removeModule = () => {
      layoutStore.removeModuleFromCurrentLayout(layoutType, moduleId);
    };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    });

    useEffect(() => {
      if (showDeletePrompt) setShowDeletePrompt(false);
    }, [selectedWatchlist]);

    return (
      <div className={style.container}>
        <header className={style.header}>
          <Body2 color={colors.lightGrey} fontWeight={700}>
            Watchlist Manager
          </Body2>
          <CloseWindowButton
            width={15}
            stroke={2}
            color={colors.red}
            handleClick={removeModule}
          />
        </header>
        <div className={style.body}>
          <div className={style.list}>
            {watchlistNameList.map((name) => (
              <WatchlistManagerListComponent
                key={name}
                watchlistName={name}
                selectedWatchlist={selectedWatchlist}
                setSelectedWatchlist={setSelectedWatchlist}
              />
            ))}
          </div>
          <Body3 fontWeight={700} color={colors.red}>
            {errorMessage}
          </Body3>
          {showDeletePrompt ? (
            <div className={style.deletePrompt}>
              <Body2 margin="0 5px 0 0" color={colors.lightGrey} fontWeight={700}>
                Delete this watchlist?
              </Body2>
              <div className={style.buttons}>
                <TextButton
                  color={colors.lightGrey}
                  fontSize="small"
                  margin="0 5px 0 0"
                  width="60px"
                  backgroundColor={colors.red}
                  clickHandler={() => {
                    alertStore.removeWatchlist(selectedWatchlist);
                    removeWatchlistName(selectedWatchlist);
                    setShowDeletePrompt(false);
                  }}
                >
                  Delete
                </TextButton>
                <TextButton
                  fontSize="small"
                  color={colors.lightGrey}
                  backgroundColor={colors.blue}
                  width="60px"
                  clickHandler={() => setShowDeletePrompt(false)}
                >
                  Cancel
                </TextButton>
              </div>
            </div>
          ) : (
            <div className={`${style.controls} noDragTag`}>
              <input
                onClick={() => setNewWatchlistName('')}
                type="text"
                value={newWatchlistName}
                onChange={({ target }) => setNewWatchlistName(target.value)}
                className={style.input}
              />
              <TextButton
                fontSize="small"
                color={colors.lightGrey}
                width="50px"
                margin="0 5px 0 0"
                height="100%"
                backgroundColor={colors.green}
                clickHandler={() => {
                  if (watchlistNameList.includes(newWatchlistName)) {
                    setErrorMessage(
                      'There is already a watchlist with that name.'
                    );
                    const timeout = setTimeout(() => {
                      setErrorMessage('');
                    }, 1000);
                    timeoutRef.current = timeout;
                  } else if (newWatchlistName === '' || !newWatchlistName) {
                    setErrorMessage('Please give your watchlist a name.');
                    const timeout = setTimeout(() => {
                      setErrorMessage('');
                    }, 1000);
                    timeoutRef.current = timeout;
                  } else {
                    alertStore.addNewWatchlist(newWatchlistName);
                    addWatchlistName(newWatchlistName);
                  }
                }}
              >
                Add
              </TextButton>
              <TextButton
                fontSize="small"
                color={colors.lightGrey}
                width="50px"
                height="100%"
                backgroundColor={colors.red}
                clickHandler={() => {
                  if (selectedWatchlist) setShowDeletePrompt(true);
                  else setErrorMessage('No watchlist selected.');
                  const timeout = setTimeout(() => {
                    setErrorMessage('');
                  }, 1000);
                  timeoutRef.current = timeout;
                }}
              >
                Delete
              </TextButton>
            </div>
          )}
        </div>
      </div>
    );
  }
);
